import { Stack, TextField} from "@mui/material"

export const FilterProducts = ({ setFilterArray, copyArray }) => {

    const handleSubmit = (e) => {
        e.preventDefault();
        const filter = e.target.value.toUpperCase();

        const newFilterArray = copyArray.filter((row) => row.product?.toUpperCase().includes(filter));

        setFilterArray(newFilterArray)
    }

    return (
        <Stack component='form' flexDirection='row' justifyContent='space-between' width='100%' mb='1rem' >
            <TextField
                label="Filtrar por producto"
                defaultValue=""
                size="small"
                name="filter"
                sx={{width:'100%'}}
                onChange={handleSubmit}
            />

        </Stack>
    )
}